export default __webpack_public_path__ + "static/media/flower.6682d151.png";